/* Custom hook just like the regular useEffect but skip the initial call */
import { useEffect, useRef } from 'react';

export default (fn: any, inputs: any) => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      fn();
    } else {
      didMountRef.current = true;
    }
    // eslint-disable-next-line
  }, inputs);
};
